import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RequestTodayCandlestick, token, userDisable, logoutClear } from './NetworkFactory';
import { initFavoriteRquestData, isFollowed } from './views/market/FavoritesManager';

const root = ReactDOM.createRoot(document.getElementById('root'));

// # ========================================================================
// # 全局币种信息
var listenerObjects = {}
var candlestickDataSource = []
var isInitCandlestickDataSource = false
const interval = 3000//process.env.NODE_ENV === 'development'? 30000000 : 3000
const requestData = () => {
  RequestTodayCandlestick().then(response => {
    try {
      let data = response.data.data || []
      data.forEach(item => {
        item['isFollowed'] = isFollowed(item.symbol)
      })
      candlestickDataSource = data
    } catch {
      candlestickDataSource = []
    }
    Object.values(listenerObjects).forEach((fuc) => {
      fuc(candlestickDataSource)
    })
  }).finally(() => {
      setTimeout(() => {
        requestData()
      }, interval)
  });
};

const initCandlestickDataSource = () => {
  if(isInitCandlestickDataSource) {
    return
  }
  isInitCandlestickDataSource = true
  // # 先初始化关注币种
  initFavoriteRquestData()
  requestData()
}

React.ListenerCandlestickDataSource = (name, fuc)=> {
  initCandlestickDataSource()
  listenerObjects[name] = fuc
  if(candlestickDataSource.length > 0) {
    fuc(candlestickDataSource)
  }
}

React.ListenerCandlestickRemove = (name)=> {
  delete listenerObjects[name]
}

React.CandlestickDataSource = () => {
  return candlestickDataSource
}


  // ========================================================================
// # 检查用户登录状态
const checkUserToken = () => {
  const userToken = token()
  if(userToken) {
    userDisable(userToken).then(response => {
      const { status = -1 } = response.data || {}
      if(status !== 200) {
        // # 清除登录状态
        logoutClear()
      }
    }).catch(error => {
      let {status = -1} = error || {}
      if(status === 401) {
        logoutClear()
      }
    })
  }
}
checkUserToken()
// ========================================================================


// # ========================================================================

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
